import React from 'react';
import LandingPage from './LandingPage';
import AboutMe from './AboutMe';
import Contact from './Contact';
import Projects from './Projects';
import Resume from './Resume';
import { Switch, Route } from 'react-router-dom';

function Main() {
	return (
		<Switch>
			<Route exact path="/" component={LandingPage} />
			<Route path="/aboutme" component={AboutMe} />
			<Route path="/contact" component={Contact} />
			<Route path="/projects" component={Projects} />
			<Route path="/resume" component={Resume} />
		</Switch>
	)
}

export default Main;
